<template>
  <!-- Where toasts appear: bottom-centre on a phone, top-right from `sm`.
       A permanent live region, so a toast that mounts inside it is announced.
       It never takes clicks itself; each toast opts back in. -->
  <div aria-live="assertive" class="pointer-events-none fixed inset-0 z-50 flex items-end px-4 py-6 sm:items-start sm:p-6">
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <slot />
    </div>
  </div>
</template>
